module.exports = __webpack_public_path__ + "img/IMG-20200319-WA0103.3d3b4b06.jpg";